import { IUserInformation } from '../../../../common/model/IUser';
import httpClient from './httpClient';
import API_ROUTES from '../constants/apiRoutes';

const userApi = {
  isLogged: () => httpClient.get<IUserInformation>(API_ROUTES.IS_LOGGED),
};

export default userApi;
